module.exports = __webpack_public_path__ + "static/img/haos-game-lucre-games-gameplay-2.156df38.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/haos/haos-game-lucre-games-gameplay-2.gif
// module id = R2Yh
// module chunks = 0